module.exports = __webpack_public_path__ + "media/images/button-prev-feb4a6ad08afd18db621943609374c5b.svg";